'use client';

import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useLayoutEffect, useRef } from 'react';
gsap.registerPlugin(ScrollTrigger, Draggable);
export default function CustomScrollbar() {
  const scrollbarRef = useRef(null);
  const thumbRef = useRef(null);
  useLayoutEffect(() => {
    const scrollbar = scrollbarRef.current;
    const thumb = thumbRef.current;
    const body = document.body;
    const contentEl = document.documentElement;
    if (!scrollbar || !thumb) return;
    let viewportHeight = window.innerHeight;
    let contentHeight = contentEl.scrollHeight;
    let scrollTimeout;
    const showScrollbar = () => {
      body.classList.add('is-scrolling');
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        body.classList.remove('is-scrolling');
      }, 1000);
    };
    const recalcSizes = () => {
      viewportHeight = window.innerHeight;
      contentHeight = contentEl.scrollHeight;
    };
    const st = ScrollTrigger.create({
      start: 0,
      end: () => contentHeight - viewportHeight,
      invalidateOnRefresh: true,
      onRefresh: () => {
        recalcSizes();
        if (contentHeight <= viewportHeight) {
          gsap.set(scrollbar, {
            autoAlpha: 0
          });
        }
      },
      onUpdate: self => {
        if (contentHeight <= viewportHeight) return;
        const thumbHeight = viewportHeight / contentHeight * viewportHeight;
        gsap.set(scrollbar, {
          autoAlpha: 1
        });
        gsap.set(thumb, {
          height: thumbHeight,
          y: self.progress * (viewportHeight - thumbHeight)
        });
        showScrollbar();
      }
    });
    const [draggable] = Draggable.create(thumb, {
      type: 'y',
      bounds: scrollbar,
      inertia: false,
      onPress: () => st.disable(),
      onDrag() {
        const maxThumbY = viewportHeight - this.target.offsetHeight;
        const progress = this.y / maxThumbY;
        window.scrollTo(0, progress * (contentHeight - viewportHeight));
        showScrollbar();
      },
      onRelease: () => st.enable(),
      onThrowComplete: () => st.enable()
    });
    const onResize = () => {
      recalcSizes();
      ScrollTrigger.refresh();
    };
    window.addEventListener('resize', onResize);
    return () => {
      st.kill();
      draggable.kill();
      clearTimeout(scrollTimeout);
      window.removeEventListener('resize', onResize);
      body.classList.remove('is-scrolling');
    };
  }, []);
  return <div ref={scrollbarRef} className='c-scrollbar'>
      <div ref={thumbRef} className='c-scrollbar_thumb' />
    </div>;
}